import React, { useEffect } from "react";
import {
  LuArrowRight,
  LuBadgeCheck,
  LuCalendarDays,
  LuClock3,
  LuMapPin,
  LuMapPinned
} from "react-icons/lu";
import { Link } from "react-router-dom";
import "../css/centurion-anniversary.scss";

const AGENDA_REGISTRATION_LINKS = {
  "Workshop": "/event/1783612827091",
  "Үзүүлэх сургалт": "/event/1783612827091",
  "International Scientific Conference \"Past and Future\"": "/annual-meetings",
  "\"Өнгөрсөн ба ирээдүй\" эрдмийн чуулган": "/annual-meetings",
  "Gala Dinner": "/event/1783607749043",
  "Баярын хүлээн авалт": "/event/1783607749043"
};

const HIDDEN_CENTURION_DATE_LABELS = [
  "Abstract submission",
  "Илтгэлийн хураангуй хүлээн авах"
];

const CENTURION_EARLY_BIRD_LABEL = "Early bird";

const getCenturionDateLabelParts = (label) => {
  const separatorIndex = label.lastIndexOf(":");

  if (separatorIndex === -1) {
    return {
      label,
      tag: ""
    };
  }

  return {
    label: label.slice(0, separatorIndex).trim(),
    tag: label.slice(separatorIndex + 1).trim()
  };
};

const getAnniversaryDateItem = (item, language) => {
  const labelParts = getCenturionDateLabelParts(item.label);
  const isEarlyBird = labelParts.tag.toLowerCase() === CENTURION_EARLY_BIRD_LABEL.toLowerCase();

  if (!isEarlyBird) {
    return {
      label: item.label,
      value: item.value,
      note: ""
    };
  }

  return {
    label: labelParts.label
      .replace(/\s+registration$/i, "")
      .replace(/\s+бүртгэл$/i, ""),
    value: item.value,
    note: language ? "Early bird ends" : "Эрт бүртгэл дуусах"
  };
};

const CenturionAnniversary = ({ data, centurion, language }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("centurion-anniversary-page");

    return () => {
      document.body.classList.remove("centurion-anniversary-page");
    };
  }, []);

  const agendaDays = data?.agendaDays || [];
  const importantDateItems = (centurion?.importantDates?.items || []).filter(
    (item) => !HIDDEN_CENTURION_DATE_LABELS.includes(item.label)
  );

  return (
    <main className="centurion-anniversary">
      <section className="centurion-anniversary-hero">
        <div className="centurion-anniversary-hero-inner">
          <div className="hero-copy">
            <span className="eyebrow">{data.eyebrow}</span>
            <h1>{data.title}</h1>
            <p>{data.description}</p>

            <div className="hero-meta">
              <div className="hero-meta-item">
                <LuClock3 size={18} />
                <span>{data.eventDate}</span>
              </div>
              <div className="hero-meta-item">
                <LuMapPin size={18} />
                <span>{data.location}</span>
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <img src={data.heroImage} alt="" />
            <div className="hero-status-panel">
              <span className="status-icon">
                <LuBadgeCheck size={20} />
              </span>
              <div>
                <span>{data.eventDate}</span>
                <strong>{data.registrationStatus}</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <CenturionSection
        centurion={centurion}
        language={language}
      /> */}

      {agendaDays.length ? (
        <section className="agenda-section">
          <div className="agenda-heading">
            <h2>{data.agendaTitle}</h2>
          </div>

          <div className="agenda-grid">
            {agendaDays.map((day) => (
              <article className="agenda-day" key={day.date}>
                <div className="agenda-date">
                  <LuCalendarDays size={20} />
                  <span>{day.date}</span>
                </div>
                <div className="agenda-event-list">
                  {day.items.map((item, index) => {
                    const registrationLink = AGENDA_REGISTRATION_LINKS[item.title];

                    if (registrationLink) {
                      return (
                        <Link
                          className="agenda-event agenda-event-link"
                          key={item.title}
                          to={registrationLink}
                        >
                          <div className="agenda-event-content">
                            <span className="agenda-event-number">
                              {String(index + 1).padStart(2, "0")}
                            </span>
                            <h3>{item.title}</h3>
                            <div className="agenda-event-venue">
                              <LuMapPinned size={17} />
                              <span>{item.venue}</span>
                            </div>
                            <span className="agenda-event-action">
                              {data.registerButton}
                              <LuArrowRight size={18} />
                            </span>
                          </div>
                        </Link>
                      );
                    }

                    return (
                      <div className="agenda-event" key={item.title}>
                        <div className="agenda-event-content">
                          <span className="agenda-event-number">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                          <h3>{item.title}</h3>
                          <div className="agenda-event-venue">
                            <LuMapPinned size={17} />
                            <span>{item.venue}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </article>
            ))}
          </div>
        </section>
      ) : null}

      <section className="anniversary-caravan" aria-hidden="true">
        <img
          src="/images/100/blue_camel_caravan.png"
          alt=""
        />
      </section>
    </main>
  );
};

export default CenturionAnniversary;
